export const config = {
  cognito: {
    REGION: "eu-west-2",
    USER_POOL_ID: "eu-west-2_x4A8HYgrC",
    APP_CLIENT_ID: "3da9ou0ga8a10300ab1ul5ntlt",
  },
};
